import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

interface option {
  text: string
  value: string | number
}
interface Props {
  value: any
  options: option[]
  required?: boolean
  disabled?: boolean
  horizontal?: boolean
  name?: string
  size?: number 
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioButtonGroup',
  props: {
    value: null,
    options: null,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    name: { default: 'radioGroup' },
    size: { default: 16 }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: boolean): void;}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any, options: option[], required: boolean, disabled: boolean, horizontal: boolean, name: string, size: number };





const cssVars = computed(() => {
  return {
  ...({'--radio-button--size': props.size + 'px'})
  }
});

function updateValue(value: any) {
  emit("input", value);
}

return { __sfc: true,emit, props, cssVars, updateValue }
}

})